export default {"src":"/_next/static/media/secondary-logo-1.4b82d9d8.svg","height":104,"width":244,"blurWidth":0,"blurHeight":0};